import { render, staticRenderFns } from "./ArticleSearchCard.vue?vue&type=template&id=2c722c9e&scoped=true"
import script from "./ArticleSearchCard.vue?vue&type=script&lang=js"
export * from "./ArticleSearchCard.vue?vue&type=script&lang=js"
import style0 from "./ArticleSearchCard.vue?vue&type=style&index=0&id=2c722c9e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c722c9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c722c9e')) {
      api.createRecord('2c722c9e', component.options)
    } else {
      api.reload('2c722c9e', component.options)
    }
    module.hot.accept("./ArticleSearchCard.vue?vue&type=template&id=2c722c9e&scoped=true", function () {
      api.rerender('2c722c9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/ArticleSearchCard.vue"
export default component.exports